import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Paper from '@material-ui/core/Paper';
import DialogContentText from '@material-ui/core/DialogContentText';
import userActions from '../actions/user_actions';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { getPermission, requestPermission } from '../utils/desktopNotifications';

// How long a sign-in will wait for an unanswered notification prompt before
// reloading anyway. Long enough to click Allow, short enough that ignoring the
// prompt is not mistaken for a broken login.
const PERMISSION_GRACE_MS = 10000;

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

/*
const styles = theme => ({
    textField: {
        height: theme.spacing.unit
    }
});
*/

export class LoginPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            password: "",
            showError: false, ///
            submitting: false,
            loginFailed: false,
            alertEmailSent: false,
            alertEmailNotFound: false,
            showPassword: false
        };
    }

    componentDidMount() {
        if (localStorage.getItem('currentUser') !== null && localStorage.getItem('token') !== null) {
            this.props.userLoggedIn();
        }
    }

    handleChange = event => {
        event.persist(); // this allows access to event properties in an asynchronous way https://reactjs.org/docs/events.html#event-pooling
        this.setState({
            [event.target.name]: event.target.value,
        });
        if (this.state.email.length > 0) this.setState({ showError: false });
        if (this.state.loginFailed) this.setState({ loginFailed: false });
    }

    //TODO: fix bug
    handleEnterSubmit = event => {
        if (event.key === 'Enter') {
            this.handleSubmit();
        }
    }

    handleSubmit = event => {
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.state.submitting) {
            return;
        }
        if (this.state.email.length > 0 && this.state.password.length > 0) {
            this.setState({ submitting: true, loginFailed: false });

            // Asked for here, inside the click, because Firefox 72+ only
            // honours a permission request that comes from a user gesture -
            // and it refuses silently, so an automatic request on load looks
            // like it worked and then never shows anything.
            //
            // Resolves immediately unless the permission is still 'default',
            // which is the only case that actually puts a prompt on screen.
            const willPrompt = getPermission() === 'default';
            const permissionSettled = requestPermission();
            // Wait for the login to answer instead of reloading on a timer. The
            // first request of a session regularly takes longer than half a
            // second - EF opening its connection, JIT - and the reload used to
            // fire before userLoginFetch had stored the token, dropping you back
            // on this form as though nothing had happened. Clicking Login a
            // second time then "worked" only because the server was warm by then.
            this.props.userLoginFetch(this.state)
                .then(() => {
                    if (localStorage.getItem("token")) {
                        // The reload below dismisses any open permission
                        // prompt, so give them a moment to answer it first.
                        // Capped, because an unanswered prompt must never be
                        // able to hold up signing in - after the grace period
                        // we reload anyway and the menu item remains the way in.
                        if (!willPrompt) {
                            window.location.reload();
                            return;
                        }
                        return Promise.race([
                            permissionSettled,
                            new Promise(resolve => setTimeout(resolve, PERMISSION_GRACE_MS)),
                        ]).then(() => { window.location.reload(); });
                    }
                    this.setState({ submitting: false, loginFailed: true });
                })
                .catch(err => {
                    console.error("api/auth/login failed:", err);
                    this.setState({ submitting: false, loginFailed: true });
                });
        } else {
            this.setState({ showError: true });
        }
    }
    ///
    /*
    removeIconColor = (event) => {
        event.target.style.color = "#adadad";
    }
    addIconColor = (event) => {
        event.target.style.color = "black";
    }
    */
    handleShowPassword = (event) => {
        this.setState({ showPassword: !this.state.showPassword });
    }
    handleCloseEmailAlert = event => {
        if (event !== undefined) {
            event.preventDefault();
        }
        this.setState({ alertEmailSent: false });
    }
    handleCloseNotFoundAlert = event => {
        if (event !== undefined) {
            event.preventDefault();
        }
        this.setState({ alertEmailNotFound: false });
    }
    sendUserDefaultPassword = (email, password) => {
        return fetch("api/auth/resetPassword", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({ email, password }),
        })
            .then(resp => resp.json())
            .then(data => {
                if (data.email === "No user with this email") {
                    // Alert -- email not found!
                    this.setState({ alertEmailNotFound: true });
                } else if (data) {
                    // ALERT -- default password has been sent by email
                    this.setState({ alertEmailSent: true });
                }
            });
    };
    generateDefaultPassword = () => {
        let length = 8,
            characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
            password = "";
        for (var i = 0, n = characters.length; i < length; ++i) {
            password += characters.charAt(Math.floor(Math.random() * n));
        }
        let regex = /^(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,16}$/;
        return regex.test(password) ? password : this.generateDefaultPassword();
    }
    handleForgottenPassword = async () => {
        // CREATE DEFAULT PASSWORD
        let defaultPassword = this.generateDefaultPassword();
        // UPDATE PROFILE WITH DEFAULT PASSWORD + SEND USER EMAIL
        this.sendUserDefaultPassword(this.state.email, defaultPassword);
    }

    render() {
        // {this.state.showError && <p style={{ color: '#ff0000', fontSize: '11px' }}>Enter valid email and password</p>}
        let loginPage, alertEmailSent, alertEmailNotFound, displayedComponent;
        loginPage =
            <Dialog
                open={this.props.currentUser === {} || localStorage.getItem("token") === null}
                onClose={this.handleClose}
                aria-labelledby="form-dialog-title"
                style={{ backgroundColor: '#adadad' }}
                // style={{ backgroundColor: '#adadad', margin: "5px !important" }}
                //TransitionComponent={Transition}
                keepMounted
                PaperProps={{ style: { minWidth: '180px', margin: '5px !important' } }}
            >
            <DialogTitle id="form-dialog-title" style={{ backgroundColor: '#3f51b5' }}>
                <div style={{ color: 'white', textAlign: 'center', fontSize: '20px', cursor: 'default' }}>TeamX</div>
            </DialogTitle>
            <DialogContent>
                <TextField
                    required
                    autoFocus
                    margin="dense"
                    fullWidth
                    name="email"
                    label="Email"
                    type="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    onKeyPress={this.handleEnterSubmit}
                    error={this.state.showError}
                    helperText={this.state.showError ? "Field is required for submission" : ""}
                    InputProps={{
                        style: { height: 34 }
                    }}
                />
                <TextField
                    required
                    autoFocus
                    margin="dense"
                    fullWidth
                    name="password"
                    label="Password"
                    type={this.state.showPassword ? "text" : "password"}
                    value={this.state.password}
                    onChange={this.handleChange}
                    onKeyPress={this.handleEnterSubmit}
                    error={this.state.showError}
                    helperText={this.state.showError ? "Field is required for submission" : ""}
                    id="password_input"
                    InputProps={{
                        style: { height: 34 }, // adjustment for .MuiInputBase-inputType-282 { height: 1.1875em } when type === password
                        endAdornment: (
                            this.state.showPassword ?
                                <VisibilityIcon onClick={this.handleShowPassword} onMouseDown={this.handleShowPassword} onMouseEnter={this.addIconColor} style={{
                                    width: "21px", height: "21px", cursor: "pointer", color: "#adadad"
                                }} />
                                :
                                <VisibilityOffIcon onClick={this.handleShowPassword} onMouseDown={this.handleShowPassword} style={{
                                    width: "21px", height: "21px", cursor: "pointer", color: "#adadad"
                                }} />
                        )
                    }}
                    />
                    {this.state.loginFailed &&
                        <p style={{ color: "#ff0000", fontSize: "11px", margin: "8px 0 0" }}>
                            That email and password did not match. Check them and try again.
                        </p>}
                </DialogContent>
                <DialogActions style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button
                        type="submit"
                        color="primary"
                        onClick={this.handleForgottenPassword}
                    >
                        Forgot Password
                    </Button>
                
                   <Button
                        type="submit"
                        color="primary"
                        onClick={this.handleSubmit}
                        disabled={this.state.submitting}
                    >
                        Login
                    </Button>
                </DialogActions>
            </Dialog>;
        alertEmailSent =
            <Dialog
                open={this.state.alertEmailSent}
                onClose={this.handleCloseEmailAlert}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ backgroundColor: '#adadad' }}
                PaperProps={{ style: { minWidth: '180px', margin: '5px !important' } }}
            >
                <Paper square>
                    <div>
                        <DialogTitle id="alert-dialog-title">
                            <span style={{ color: "blue" }}>Email Sent</span>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                A default password has been sent to the provided email address. Please use this password to login.
                   </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseEmailAlert} style={{ color: "blue" }}>Ok</Button>
                        </DialogActions>
                    </div>
                </Paper>
            </Dialog>;
        alertEmailNotFound = 
            <Dialog
                open={this.state.alertEmailNotFound}
                onClose={this.handleCloseNotFoundAlert}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ backgroundColor: '#adadad' }}
                PaperProps={{ style: { minWidth: '180px', margin: '5px !important' } }}
            >
                <Paper square>
                    <div>
                        <DialogTitle id="alert-dialog-title">
                            <span style={{ color: "red" }}>Email Not Found</span>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                The email you have provided does not match any email in our records. Please try again.
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseNotFoundAlert} style={{ color: "red" }}>Ok</Button>
                        </DialogActions>
                    </div>
                </Paper>
            </Dialog>;
        if (this.state.alertEmailSent) {
            displayedComponent = alertEmailSent;
        } else if (this.state.alertEmailNotFound) {
            displayedComponent = alertEmailNotFound;
        } else {
            displayedComponent = loginPage;
        }
    return (
      <div>
        { displayedComponent }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  userLoginFetch: userInfo => dispatch(userActions['USER_LOGIN_AND_PROFILE'](userInfo)),
  userLoggedIn: () => dispatch(userActions['USER_LOGGED_IN']())
})

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/LoginPage.js